import { createReducer, on } from '@ngrx/store';
import * as SquareDeviceTypeActions from './square-device-type.actions';
import { SquareDeviceType } from './square-device-type.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SquareDeviceTypesState {
    squareDeviceTypes: SquareDeviceType[];
    squareDeviceType: SquareDeviceType | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialSquareDeviceTypesState: SquareDeviceTypesState = {
    squareDeviceTypes: [],
    squareDeviceType: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

export const squareDeviceTypesReducer = createReducer(
    initialSquareDeviceTypesState,

    // On Load All
    on(SquareDeviceTypeActions.loadSquareDeviceTypes, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareDeviceTypeActions.loadSquareDeviceTypesSuccess, (state, { squareDeviceTypes }) => ({
        ...state,
        isLoading: false,
        squareDeviceTypes,
    })),
    on(SquareDeviceTypeActions.loadSquareDeviceTypesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Load Single
    on(SquareDeviceTypeActions.loadSquareDeviceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareDeviceTypeActions.loadSquareDeviceTypeSuccess, (state, { squareDeviceType }) => ({
        ...state,
        isLoading: false,
        squareDeviceType,
    })),
    on(SquareDeviceTypeActions.loadSquareDeviceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Create
    on(SquareDeviceTypeActions.createSquareDeviceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareDeviceTypeActions.createSquareDeviceTypeSuccess, (state, { squareDeviceType }) => ({
        ...state,
        isLoading: false,
        squareDeviceTypes: [...(state.squareDeviceTypes || []), squareDeviceType],
    })),
    on(SquareDeviceTypeActions.createSquareDeviceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Update
    on(SquareDeviceTypeActions.updateSquareDeviceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareDeviceTypeActions.updateSquareDeviceTypeSuccess, (state, { squareDeviceType }) => ({
        ...state,
        isLoading: false,
        squareDeviceTypes: state.squareDeviceTypes.map((s) =>
            s.id === squareDeviceType.id ? squareDeviceType : s
        ),
    })),
    on(SquareDeviceTypeActions.updateSquareDeviceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Delete
    on(SquareDeviceTypeActions.deleteSquareDeviceType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareDeviceTypeActions.deleteSquareDeviceTypeSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        squareDeviceTypes: state.squareDeviceTypes.filter((s) => s.id !== id),
    })),
    on(SquareDeviceTypeActions.deleteSquareDeviceTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    }))
);
